export class RateLimitError extends Error {}

export class ResourceNotFoundError extends Error {}

export class ForbiddenError extends Error {}

export class UnauthorizedError extends Error {}

export class NotAvailableError extends Error {}

export interface ErrorResponse {
  error: string;
  file?: string;
  internal_code?: string;
  line?: number;
  log_error?: string;
  stack?: unknown;
}

export function isErrorResponse(arg: unknown): arg is ErrorResponse {
  if (!arg) {
    return false;
  }

  return Object.prototype.hasOwnProperty.call(arg, 'error');
}
